/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    format,
} from 'date-fns';
import browserAgnosticNewDate from './browserAgnosticDate/browserAgnosticDate';

const dayOfWeekConverter = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};

const monthConverter = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

// This function converts an object that we get back from our delivery calendar API
// into a format used with Apple Pay

export const applePayDateConverter = (dateArray, baseShippingCharge = '0.00', surchargeEnabled = false) => {  // eslint-disable-line import/prefer-default-export
    const resultsArr = dateArray.flatMap((dateObj) => {
        //   let returnObj = {};
        const fullDeliveryDate = dateObj.deliveryDate.split('-');
        const newDateFormat = new Date(
            fullDeliveryDate[0],
            fullDeliveryDate[1] - 1,
            fullDeliveryDate[2],
        );
        const dayOfWeek = dayOfWeekConverter[newDateFormat.getDay()];
        const labelMonth = monthConverter[fullDeliveryDate[1]];
        const label = `${dayOfWeek} - ${labelMonth} ${newDateFormat.getDate()} ${fullDeliveryDate[0]}`;

        let amount = Number(dateObj.baseCharge) > 0 ? Number(dateObj.baseCharge) : Number(baseShippingCharge);
        const surcharges = Number(dateObj.totSurcharge) || Number(dateObj.surcharge) || 0;
        const upcharges = Number(dateObj.upcharge) || 0;

        if (surchargeEnabled) {
            amount += surcharges + upcharges;
        }

        if (dateObj.flexDetails) {
            return dateObj.flexDetails.option.map((option) => {
                let flexAmount = amount;
                const flexMessage = option.flexMsg?.find((message) => message.msgTypeLocation === 'Product')?.msgText?.replace('<br>', '-');
                const flexIdentifier = {
                    deliverySLA: dateObj.deliverySLA,
                    calendarDateType: dateObj.calendarDateType,
                    flexOptionId: option.optionCode,
                    flexOptionKey: option.optionKey,
                    flexVariantId: dateObj.flexDetails.variantId,
                };

                if (dateObj.flexDetails.forceFlex === 'true') {
                    const overrideDeliveryDate = format(browserAgnosticNewDate(option.forcedDelDate), 'yyyy-MM-dd');

                    const [year, month, day] = overrideDeliveryDate.split('-');
                    // override the date to the force delivery date
                    flexIdentifier.deliveryDate = `${month}/${day}/${year} 00:00:00"`;
                } else {
                    flexIdentifier.deliveryDate = `${fullDeliveryDate[1]}/${fullDeliveryDate[2]}/${fullDeliveryDate[0]} 00:00:00`;
                }
                if (surchargeEnabled) {
                    flexAmount += (Number(option.flexAmount) || 0);
                }

                return {
                    label,
                    amount: flexAmount,
                    identifier: JSON.stringify(flexIdentifier),
                    detail: flexMessage,
                };
            });
        }

        let additionalDetails = '';
        if (surcharges > 0) {
            additionalDetails = ` + $${dateObj.surcharge}`;
        }

        const detail = `Std. Shipping${additionalDetails}`;
        const identifier = {
            deliverySLA: dateObj.deliverySLA,
            calendarDateType: dateObj.calendarDateType,
            deliveryDate: `${fullDeliveryDate[1]}/${fullDeliveryDate[2]}/${fullDeliveryDate[0]} 00:00:00`,
        };
        return {
            label,
            amount,
            detail,
            identifier: JSON.stringify(identifier),
        };
    });

    return resultsArr;
};
